import React from 'react';
import styles from './Pagination.module.css';
import Icon from './Icon';

export default function Pagination({ children, className = '', ...rest }) {
  return (
    <nav className={`${styles.pagination} ${className}`} {...rest}>
      {children}
    </nav>
  );
}

Pagination.Item = function PaginationItem({ children, active = false, disabled = false, onClick, className = '', ...rest }) {
  return (
    <button
      className={`${styles.item} ${active ? styles.active : ''} ${disabled ? styles.disabled : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

Pagination.First = function PaginationFirst({ onClick, disabled = false, ...rest }) {
  return (
    <Pagination.Item onClick={onClick} disabled={disabled} {...rest}>
      <Icon name="fa-angle-double-left" size="sm" />
    </Pagination.Item>
  );
};

Pagination.Prev = function PaginationPrev({ onClick, disabled = false, ...rest }) {
  return (
    <Pagination.Item onClick={onClick} disabled={disabled} {...rest}>
      <Icon name="fa-angle-left" size="sm" />
    </Pagination.Item>
  );
};

Pagination.Next = function PaginationNext({ onClick, disabled = false, ...rest }) {
  return (
    <Pagination.Item onClick={onClick} disabled={disabled} {...rest}>
      <Icon name="fa-angle-right" size="sm" />
    </Pagination.Item>
  );
};

Pagination.Last = function PaginationLast({ onClick, disabled = false, ...rest }) {
  return (
    <Pagination.Item onClick={onClick} disabled={disabled} {...rest}>
      <Icon name="fa-angle-double-right" size="sm" />
    </Pagination.Item>
  );
};
